import { z } from "zod";

export const offerChoicesSchema = z.object({
  question: z.string().describe("The short question to ask"),
  options: z.array(z.string()).min(2).max(6).describe("2-6 options drawn from what you found, as short labels"),
  multiple: z.boolean().default(false).describe("True when several options can be picked, e.g. services"),
  allow_other: z
    .boolean()
    .default(false)
    .describe("True to add an 'Other' box for free text - only when you can act on whatever they type"),
});
